'use strict';

require('./FormAppSubmitGroupService.js');
require('./FormAppSubmitGroupUserService.js');


function FormAppSubmitGroupNewCtrl(
  $scope,
  translations,
  $state,
  $stateParams,
  growl,
  FormAppSubmitGroupService,
  CurrentUserService,
  FormAppSubmitGroupUserService) {
  $scope.formAppGroup = new FormAppSubmitGroupService({});
  $scope.state = $state;

  $scope.save = function() {
    $scope.formAppGroup.$save({companyId: $stateParams.companyId}, function(resp, headers) {
      $scope.formAppGroupForm.$setPristine();
      var newId = headers('Location').split('/').pop();
      if($scope.addCurrentUser) {
        CurrentUserService.get().then(function(user) {
          FormAppSubmitGroupUserService.save({companyId: $stateParams.companyId, groupId: newId}, user);
        });
      }
    $state.go('root.company.formAppGroups.detail', {companyId: $stateParams.companyId, groupId: newId});
    growl.addSuccessMessage(translations['form-app.create-success']);
    }, function(resp) {
      if (resp.status === 400 && resp.data.error && resp.data.error.code === 1613) {
        growl.addErrorMessage(translations['form-app.reached-your-limit']);
      } else {
        growl.addErrorMessage(translations['form-app.create-failure']);
      }
    });
  };
}

FormAppSubmitGroupNewCtrl.resolve = {
  translations: ['$translate', function($translate) {
    return $translate([
      'form-app.create-success',
      'form-app.create-failure',
      'form-app.reached-your-limit'
    ]);
  }]
};
module.exports = FormAppSubmitGroupNewCtrl;

angular.module('dokiv')
  .controller('FormAppSubmitGroupNewCtrl', [
    '$scope',
    'translations',
    '$state',
    '$stateParams',
    'growl',
    'FormAppSubmitGroupService',
    'CurrentUserService',
    'FormAppSubmitGroupUserService',
    FormAppSubmitGroupNewCtrl]);




//////////////////
// WEBPACK FOOTER
// ./scripts/company/form-app-submit-group/FormAppSubmitGroupNewCtrl.js
// module id = 352
// module chunks = 0